module.exports = __webpack_public_path__ + "zip/origfac8x11.zip";